import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { useState, useEffect } from 'react';
import { __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import Box from '../Box/index.esm.js';
import AnimateHeight from 'react-animate-height';

var Collapse = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var open = props.open,
      _props$animateOpacity = props.animateOpacity,
      animateOpacity = _props$animateOpacity === void 0 ? true : _props$animateOpacity,
      onAnimationStart = props.onAnimationStart,
      onAnimationEnd = props.onAnimationEnd,
      duration = props.duration,
      _props$easing = props.easing,
      easing = _props$easing === void 0 ? 'ease' : _props$easing,
      _props$startingHeight = props.startingHeight,
      startingHeight = _props$startingHeight === void 0 ? 0 : _props$startingHeight,
      _props$endingHeight = props.endingHeight,
      endingHeight = _props$endingHeight === void 0 ? 'auto' : _props$endingHeight,
      _props$alwaysRenderCh = props.alwaysRenderChildren,
      alwaysRenderChildren = _props$alwaysRenderCh === void 0 ? false : _props$alwaysRenderCh,
      rest = _objectWithoutPropertiesLoose(props, ["open", "animateOpacity", "onAnimationStart", "onAnimationEnd", "duration", "easing", "startingHeight", "endingHeight", "alwaysRenderChildren"]);

  var _useState = useState(false),
      renderChildren = _useState[0],
      setRenderChildren = _useState[1]; // Set renderChildren on open


  useEffect(function () {
    if (open) {
      setRenderChildren(true);
    }
  }, [open]);

  var animationEndHandler = function animationEndHandler(args) {
    if (onAnimationEnd) {
      onAnimationEnd(args);
    } // Delay hiding children until close animation is complete to prevent jank


    if (!alwaysRenderChildren && !open) {
      setRenderChildren(false);
    }
  };

  return React__default.createElement(AnimateHeight, {
    ref: ref,
    duration: duration,
    easing: easing,
    animateOpacity: animateOpacity,
    height: open ? endingHeight : startingHeight,
    applyInlineTransitions: true,
    onAnimationStart: onAnimationStart,
    onAnimationEnd: animationEndHandler
  }, (alwaysRenderChildren || renderChildren || open) && React__default.createElement(Box, _extends({}, rest)));
});

if (__DEV__) {
  Collapse.displayName = 'Collapse';
}

export default Collapse;
//# sourceMappingURL=index.esm.js.map
